import React from "react";
import { ToggleSwitchWrapper } from "./assets/style";
import { Icon } from "@nykaa/payment-ui/src/Icon";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../helpers";


interface IToggle {
  isChecked: boolean;
  id?: string;
  onToggle?: () => void;
  dataTestId?: string;
  className?: string;
}

export const ToggleSwitch = ({
  isChecked,
  id,
  onToggle,
  dataTestId = "",
  className = "",
}: IToggle) => {
  const platform = getPlatform();
  return (
    <ToggleSwitchWrapper isChecked={isChecked} className={className}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events*/}
      <span
        onClick={e => {
          onToggle && e.preventDefault();
          onToggle && onToggle();
        }}
      >
        <label htmlFor="checkWallet" className="switch" data-testid={dataTestId}>
          <input id={id} type="checkbox" checked={!!isChecked} />
          <span className="slider round">
            <div className="control__indicator">
              <Icon icon={getIcons(platform, ICONS_NAMES.TICK_ICON)} />
            </div>
          </span>
        </label>
      </span>
    </ToggleSwitchWrapper>
  );
};
